function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getPriceViewCookie() {
    const raw = getCookie('user_selected_price_view');
    if (!raw) return null;

    try {
        return JSON.parse(decodeURIComponent(raw));
    } catch (e) {
        // Keep compatibility with preferences saved before cookie encoding was added.
        try {
            return JSON.parse(raw);
        } catch (legacyError) {
            console.warn('user_selected_price_view cookie is not valid JSON');
            return null;
        }
    }
}

function setPriceViewCookie(contractType) {
    const payload = {
        current_contract_type: contractType
    };

    setCookie('user_selected_price_view', encodeURIComponent(JSON.stringify(payload)), 365);
}

document.addEventListener('DOMContentLoaded', () => {
    changeTooltipText();
    const pageContractType = document.body.dataset.contractType;

    const path = window.location.pathname;
    const isVanLeasing = path.includes('van-leasing');
    const isCarLeasing = path.includes('car-leasing');
    const isCarLeasingBusiness = path.includes('car-leasing/business');
    const saved = getPriceViewCookie();

    // console.log('saved ' + saved);

    // Derivative pages use the deal type resolved by price_view(true).
    // Other pages use the saved preference or their leasing section default.
    let contract_selected = pageContractType
        ? (pageContractType.toLowerCase().startsWith('personal') ? 'personal' : 'business')
        : (saved && saved.current_contract_type ? saved.current_contract_type : null);

    if (!contract_selected && isVanLeasing) {
        contract_selected = 'business';
    } else if (!contract_selected && isCarLeasingBusiness) {
        contract_selected = 'business';
    } else if (!contract_selected && isCarLeasing) {
        contract_selected = 'personal';
    }

    // console.log(contract_selected);

    // if we managed to figure out a contract apply it
    if (contract_selected) {
        toggleSwitches(contract_selected);
        togglePrices(contract_selected);
        updateCheckEligibilityViewOfferContainer(contract_selected);
        updatePrices(contract_selected);
    }
});

function updateCheckEligibilityViewOfferContainer(value) {
    const containers = document.querySelectorAll(".check_eligibility_view_offer_container");

    containers.forEach(container => {
        const eligibilityBtn = container.querySelector(".check_eligibility_btn");
        const eligibilityDerivativeBtn = container.querySelector(".check_eligibility_derivative_btn");
        const viewOfferBtn = container.querySelector(".view_offer_btn");
        const businessTypes = document.querySelector('#business_types');

        if (value == "personal") {
            if (eligibilityBtn) {
                eligibilityBtn.classList.remove("hidden");
            }
            if (eligibilityDerivativeBtn) {
                eligibilityDerivativeBtn.classList.remove("opacity-0");
            }

            if (viewOfferBtn) {
                viewOfferBtn.classList.remove("w-full");
                viewOfferBtn.classList.add("w-1/2");
            }
            if (businessTypes) {
		        businessTypes.style.display = 'none';
		    }

        } else {
            if (eligibilityBtn) {
                eligibilityBtn.classList.add("hidden");
            }
            if (eligibilityDerivativeBtn) {
                eligibilityDerivativeBtn.classList.add("opacity-0");
            }

            if (viewOfferBtn) {
                viewOfferBtn.classList.remove("w-1/2");
                viewOfferBtn.classList.add("w-full");
            }
            if (businessTypes) {
		        businessTypes.style.display = '';
		    }
        }
    });

	changeTooltipText();
}

document.querySelectorAll('.price-toggle').forEach(wrapper => {
    wrapper.addEventListener('change', e => {
        if (!e.target.matches('.toggle-personal, .toggle-business')) return;
        const raw = e.target.value.toLowerCase();
        const mode = raw === 'personal' ? 'personal' : 'business';

        const quoteForm = document.getElementById('quote-form');

        toggleSwitches(mode);
        if (quoteForm) loadPrice();
        togglePrices(mode);
        updatePrices(mode);
        updateCheckEligibilityViewOfferContainer(mode);
        // colourDropdownInit();
        // initialiseOptionalExtras();


        setPriceViewCookie(mode);

        if (document.body.dataset.contractType) {
            document.body.dataset.contractType = mode === 'personal' ? 'Personal' : 'Business - Contract Hire';
            const url = new URL(window.location.href);
            url.searchParams.set('type', mode === 'personal' ? 'Personal' : 'Business');
            window.history.replaceState(window.history.state, '', url);
        }
    });
});

function toggleSwitches(mode) {
	document.querySelectorAll('.price-toggle').forEach(wrapper => {
		const personalRadios = wrapper.querySelectorAll('.toggle-personal');
		const businessRadios = wrapper.querySelectorAll('.toggle-business');
		const switchInputs   = wrapper.querySelectorAll('.switch-price-type');

        // Type toggle inputs for search forms
        const typeInputs               = document.querySelectorAll('[action="/search"] [name="type"]');
        // Type toggle inputs for derivative quote forms
		const typeInputsDerivative     = document.querySelectorAll('#quote-form [name="type"], #quote-form [name="deal_type"]');

		if (mode === 'personal') {
			personalRadios.forEach(r => r.checked = true);
			businessRadios.forEach(r => r.checked = false);
			switchInputs.forEach(i => i.value = 'Personal');
            typeInputs.forEach(i => i.value = 'personal');
			typeInputsDerivative.forEach(i => i.value = 'Personal');

		} else {
			personalRadios.forEach(r => r.checked = false);
			businessRadios.forEach(r => r.checked = true);
			switchInputs.forEach(i => i.value = 'Business');
            typeInputs.forEach(i => i.value = 'Business');
			typeInputsDerivative.forEach(i => i.value = 'Business - Contract Hire');

		}
	});

    contractTypeText(mode);
	changeTooltipText();
}

function contractTypeText(mode) {
    const companyOnly = document.querySelectorAll('.company-only');
    const switchText  = document.querySelectorAll('.contract-type-text');

    switchText.forEach(text => {
        if (mode === 'personal') {
            text.innerHTML = 'Personal';
        } else {
            text.innerHTML = 'Business';
        }
    });

    companyOnly.forEach(el => {
        if (mode === 'personal') {
            el.classList.add('hidden');
        } else {
            el.classList.remove('hidden');
        }
    });
}

function togglePrices(mode) {
	const priceEls = document.querySelectorAll('.price-output');
	const vatNoteEls = document.querySelectorAll('.vat-note');

	priceEls.forEach(el => {
		const price = mode === 'personal' ? el.dataset.pch : el.dataset.bch;

		if (price) {
			el.innerText = price === 'POA' || price.startsWith('£') ? price : `£${price}`;

			const priceContainer = el.parentElement;
			if (priceContainer) {
				priceContainer.querySelectorAll('.price-prefix, .price-suffix').forEach(label => {
					label.classList.toggle('hidden', price === 'POA');
				});
			}
		}
	});

	document.querySelectorAll('.contract-price-type').forEach(el => {
		const contractType = mode === 'personal' ? el.dataset.pch : el.dataset.bch;
		if (contractType) el.innerText = contractType;
	});

	document.querySelectorAll('[data-pch-url][data-bch-url]').forEach(link => {
		const url = mode === 'personal' ? link.dataset.pchUrl : link.dataset.bchUrl;
		if (url) link.setAttribute('href', url);
	});

	vatNoteEls.forEach(el => {
		el.innerText = mode === 'personal' ? 'inc. VAT per month' : '+ VAT per month';
	});
}

function updatePrices(mode) {
  document.querySelectorAll('form.price-toggle').forEach(form => {
    if (!(form instanceof HTMLFormElement)) return;

    const url = form.getAttribute('action');
    const formData = new FormData(form);
    const token = form.querySelector('[name="_token"]')?.value;

    if (!url || !token) return;

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-TOKEN': token,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    .then(res => {
      if (!res.ok) throw new Error(`Status ${res.status}`);
      return res.json();
    })
    .then(data => {
      const tokenInput = form.querySelector('[name="_token"]');
      if (tokenInput) tokenInput.value = data.token;
    })
    .catch(console.error);
  });
}


function changeTooltipText() {

    let selectedValue = null;

    // step 1: check Personal / Business first
    const toggleSelectors = [
        'input[name="toggle"][value="Personal"]',
        'input[name="toggle"][value="Business"]'
    ];

    for (let sel of toggleSelectors) {
        const el = document.querySelector(sel);
        if (el && el.checked && el.offsetParent !== null) {
            selectedValue = el.value;
            break;
        }
    }

    // step 2: if Business was selected, refine it using the special radios
    if (selectedValue === "Business") {
        const businessSelectors = ['#type-business', '#type-business-finance'];
        for (let sel of businessSelectors) {
            const el = document.querySelector(sel);
            if (el && el.checked && el.offsetParent !== null) {
                selectedValue = el.value;
                break;
            }
        }
    }

    const tooltipEl = document.querySelector('.tooltip');
    if (tooltipEl && selectedValue && lease_type_tooltip_array[selectedValue]) {
        tooltipEl.setAttribute('data-tooltip', lease_type_tooltip_array[selectedValue]);
    }
}
